export default {
  name: 'PublicPagination',
  props: {
    page: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showPageNavigation: {
      type: Boolean,
      default: true,
    },
    showPageSize: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: null,
    },
    pageSizeOptions: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
    pageSizeLabel: {
      type: String,
      default: null,
    },
    showPageSizeLabel: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['first', 'prev', 'next', 'last', 'update:pageSize', 'page-size-change'],
  computed: {
    resolvedLabel() {
      return this.label || this.$t('common.pagination');
    },
    resolvedPageSizeLabel() {
      return this.pageSizeLabel || this.$t('common.pageSize');
    },
    isFirstPage() {
      return this.page <= 1;
    },
    isLastPage() {
      return this.page >= this.totalPages;
    },
    isFirstDisabled() {
      return this.disabled || this.isFirstPage;
    },
    isLastDisabled() {
      return this.disabled || this.isLastPage;
    },
    normalizedPageSizeOptions() {
      return this.pageSizeOptions
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value) && value > 0);
    },
    selectedPageSize: {
      get() {
        return this.pageSize ?? this.normalizedPageSizeOptions[0] ?? null;
      },
      set(value) {
        const nextValue = Number(value);
        if (!Number.isFinite(nextValue) || nextValue <= 0) return;

        this.$emit('update:pageSize', nextValue);
        this.$emit('page-size-change', nextValue);
      },
    },
  },
};
